import React from "react";
import Modal from "./common/Modal";
import { useTranslation } from "react-i18next";

export const DownloadAppModal = ({ open, handleClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      maxWidth="2xl"
      maxHeight="fit-content"
      bodyPadding="tw-px-6 tw-py-8 md:tw-px-8 md:tw-py-10"
      headerPadding="tw-pl-6 tw-pr-4 tw-pt-3 md:tw-pl-8 md:tw-pr-5 md:tw-pt-4"
      showCloseButton={true}
      preventOutsideClick={false}
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center">
        {/* Header Section */}
        <div className="tw-mb-6 tw-space-y-3 md:tw-mb-8 md:tw-space-y-4">
          <h2 className="tw-text-2xl tw-font-bold tw-tracking-tight tw-text-gray-900 md:tw-text-3xl">
            {t("only_available_on_our_app", {
              defaultValue: "Only available in the app",
            })}
          </h2>
          <p className="tw-mx-auto tw-max-w-md tw-text-sm tw-leading-relaxed tw-text-gray-600 md:tw-text-base">
            {t("download_our_app_to_get_access", {
              defaultValue:
                "Download our app to get access to free reservations and exclusive welcome deals",
            })}
          </p>
        </div>

        {/* QR Code Section */}
        <div className="tw-mb-8 tw-flex tw-flex-col tw-items-center md:tw-mb-10">
          <div className="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-2xl tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100 tw-p-4 tw-shadow-inner md:tw-p-6">
            <img
              src="/images/qr-to-app-explore-page.png"
              className="tw-h-48 tw-w-48 tw-rounded-xl tw-shadow-lg md:tw-h-56 md:tw-w-56"
              alt="QR Code to download app"
            />
          </div>
          <p className="tw-mt-4 tw-text-xs tw-text-gray-500 md:tw-text-sm">
            Scan to download on your phone
          </p>
        </div>

        {/* App Store Buttons */}
        <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-3 sm:tw-flex-row sm:tw-justify-center">
          <button
            onClick={() =>
              window.open("https://apps.apple.com/sg/app/sotravel/id6447177449", "_blank")
            }
            className="tw-group tw-relative tw-transition-all tw-duration-200 hover:tw-scale-105 active:tw-scale-95"
            aria-label="Download on App Store"
          >
            <img
              src="/images/AppleDownloadIcon.png"
              className="tw-h-12 tw-w-auto tw-drop-shadow-md tw-transition-all tw-duration-200 group-hover:tw-drop-shadow-lg md:tw-h-14"
              alt="Download on App Store"
            />
          </button>
          <button
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.sotravel.sotravel",
                "_blank"
              )
            }
            className="tw-group tw-relative tw-transition-all tw-duration-200 hover:tw-scale-105 active:tw-scale-95"
            aria-label="Get it on Google Play"
          >
            <img
              src="/images/GooglePlayDownloadIcon.png"
              className="tw-h-12 tw-w-auto tw-drop-shadow-md tw-transition-all tw-duration-200 group-hover:tw-drop-shadow-lg md:tw-h-14"
              alt="Get it on Google Play"
            />
          </button>
        </div>
      </div>
    </Modal>
  );
};
